import { css } from 'styled-components';
// These are not semantically named because they are reliant on BKJThemeCheckbox color scheme
export const BKJThemeCheck = {
    GreenSolid: css `
    ${({ theme }) => theme.colors.White};
  `,
    GreenNoBorder: css `
    ${({ theme }) => theme.colors.AccentGreen};
  `,
    PurpleOutlined: css `
    ${({ theme }) => theme.colors.AccentPurple};
  `,
    PurpleSolid: css `
    ${({ theme }) => theme.colors.White};
  `,
};
//# sourceMappingURL=BKJCheck.theme.js.map